const originalFaviconUrls = new Map();
let originalTitle = '';
let displayedCount = null;

const getFaviconLinks = () => document.querySelectorAll('link[rel~="icon"]');

const rememberOriginalFavicons = () => {
  getFaviconLinks().forEach(link => {
    if (!originalFaviconUrls.has(link))
      originalFaviconUrls.set(link, link.href);
  });
  if (!originalTitle) originalTitle = document.title;
};

const badgeDataUrl = count => {
  const label = count > 99 ? '99+' : String(count);
  let fontSize = 38;
  if (label.length > 2) fontSize = 26;
  else if (label.length > 1) fontSize = 32;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64"><circle cx="32" cy="32" r="30" fill="#2563eb"/><circle cx="45" cy="19" r="17" fill="#dc2626"/><text x="45" y="27" text-anchor="middle" font-family="Arial,sans-serif" font-size="${fontSize}" font-weight="700" fill="white">${label}</text></svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

export const updateFaviconBadge = unreadCount => {
  rememberOriginalFavicons();
  const parsedCount = Number(unreadCount);
  const count = Number.isFinite(parsedCount)
    ? Math.max(0, Math.floor(parsedCount))
    : 0;
  if (displayedCount === count) return;
  displayedCount = count;
  const badge = count > 0 ? badgeDataUrl(count) : null;
  getFaviconLinks().forEach(link => {
    link.href = badge || originalFaviconUrls.get(link);
  });
  const titleCount = count > 99 ? '99+' : count;
  document.title =
    count > 0 ? `(${titleCount}) ${originalTitle}` : originalTitle;
};
